import FormationPage from "./FormationPage";

export default FormationPage;